import api from "./api";

export const paymentService = {
  listPayments: (params = {}) => api.get("/payments", { params }),
  getPayment: (id) => api.get(`/payments/${id}`),
  downloadPaymentsExcel: (params = {}) =>
    api.get("/payments/export", { params, responseType: "blob" }),
};
